import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { formatDateOrdinal } from './date_util';

export const InvoiceDetail = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);

  const logoutUser = () => {
    dispatch({ type: 'LOG_OUT', payload: null });
    sessionStorage.setItem('currentUser', null);
    window.location = "/";
  };

  useEffect(() => {
    fetchInvoice();
  }, [id]);

  const fetchInvoice = async() => {
    const response = await fetch(`/apiinvoice/${id}`, { credentials: 'include' });
    const invoiceData = await response.json();
    if (invoiceData && invoiceData.sessionExpired) {
      logoutUser();
      return;
    }
    setInvoice(invoiceData);
  }

  const formatDate = (dateString) => {
    const formatted = formatDateOrdinal(dateString);
    return formatted || 'N/A';
  }

  const formatCurrency = (value) => {
    if (!value || isNaN(parseFloat(value))) return "$0.00";
    return `$${parseFloat(value).toFixed(2)}`;
  }

  const formatHours = (value) => {
    if (!value || isNaN(parseFloat(value))) return "0.00";
    return parseFloat(value).toFixed(2);
  }

  if (!invoice) {
    return (
      <div className="location">
        <div className="locationDetailsWrapper">
          <p>Loading invoice...</p>
        </div>
      </div>
    );
  }

  //6, 7, 31, 14, 15, 122, 135
  const headers = (
    <tr>
      <th>Invoice Number</th>
      <th>Invoice Date</th>
      <th>Due Date</th>
      <th>Paid Status</th>
      <th>First Shift Start</th>
      <th>Last Shift Start</th>
      <th>Total with Tax</th>
    </tr>
  );

  const invoiceNumber = invoice && invoice[6] ? invoice[6].value : "N/A";
  const invoiceDate = invoice && invoice[7] ? formatDate(invoice[7].value) : "N/A";
  const dueDate = invoice && invoice[31] ? formatDate(invoice[31].value) : "N/A";
  const paidStatus = invoice && invoice[122] ? invoice[122].value : false;
  const status = (() => {
    if (paidStatus) return { text: 'Paid', color: 'limegreen' };
    const dueRaw = invoice && invoice[31] ? invoice[31].value : null;
    if (dueRaw) {
      const due = new Date(dueRaw);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (!isNaN(due.getTime()) && due < today) {
        return { text: 'Past Due', color: 'crimson' };
      }
    }
    return { text: 'Payment Pending', color: 'orange' };
  })();
  const firstShiftStart = invoice && invoice[14] ? formatDate(invoice[14].value) : "N/A";
  const lastShiftStart = invoice && invoice[15] ? formatDate(invoice[15].value) : "N/A";
  const totalWithTax = invoice && invoice[135] ? formatCurrency(invoice[135].value) : "$0.00";
  const hourlyRate = invoice && invoice[86] ? formatCurrency(invoice[86].value) : "$0.00";
  const hasPdf = false;
  const pdfUrl = hasPdf ? `https://guardservicesusa.quickbase.com/up/bsbjuzyzm/a/r${id}/e150/v0` : null;

  return (
    <div className="location">
      <div className="locationDetailsWrapper">
        <h2>Invoice #{invoiceNumber}</h2>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '12px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', fontWeight: 'bold', fontSize: '18px', color: '#222' }}>
            <span style={{ width: '16px', height: '16px', borderRadius: '50%', backgroundColor: status.color, flexShrink: 0 }}></span>
            {status.text}
          </div>
          {pdfUrl && (
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="mainButton" style={{ display: 'inline-block', textDecoration: 'none', margin: 0 }}>
              View Invoice PDF
            </a>
          )}
        </div>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Invoice Number</p><p className="field">{invoiceNumber}</p>
          </div>
        </div>

          <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Invoice Date</p><p className="field">{invoiceDate}</p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Due Date</p><p className="field">{dueDate}</p>
          </div>
        </div>

        <h3 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '18px', fontWeight: 'bold' }}>Shift Dates</h3>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">First Shift Start Date</p><p className="field">{firstShiftStart}</p>
          </div>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Last Shift Start Date</p><p className="field">{lastShiftStart}</p>
          </div>
        </div>

        <h3 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '18px', fontWeight: 'bold' }}>Invoice Total</h3>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Invoice Total</p><p className="field">{totalWithTax}</p>
          </div>
          
        </div>

      </div>
    </div>
  );
}
